import { AppService } from './../../../app.service';
import { Component, OnInit } from '@angular/core';
import { Constants, MessageUtil } from 'src/app/helpers/messages';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss']
})
export class AccountSettingsComponent implements OnInit {
  userDetails = this.app.helperService.getFromStore(Constants.LOGIN_USER)
  userForm: FormGroup;
  picPreview: string | ArrayBuffer;
  selectedPic: any;
  picLoading: boolean;


  constructor(private app: AppService, private fb: FormBuilder,) {
    this.app.getPicture().subscribe(el=>{this.picPreview = el})    
  }

  ngOnInit(): void {
    // this.getProfilePic()
    // console.log(this.userDetails)
  }

  uploadImage(event) {
    this.selectedPic = event.target.files[0];
    this.picLoading = true

    let userid = this.app.helperService.getUserId()

    let formData = new FormData(); 
    formData.append('file', this.selectedPic, this.selectedPic.name);

    this.app.userService.uploadPhoto(userid, formData)
      .subscribe(res => {
        if (res['message'] == MessageUtil.RESPONSE_SUCCESS) {
          this.app.snackBar.open(res['data'], 'Dismiss',{
            duration: MessageUtil.TIMEOUT_DURATION
          })
          this.getProfilePic()
        }
        
        else {
          this.app.snackBar.open(MessageUtil.UPLOAD_ERROR, 'Dismiss',{
            duration: MessageUtil.TIMEOUT_DURATION
          })
          this.picLoading = false
        }
    })
  }

  getProfilePic() {
    let userid = this.app.helperService.getUserId()
    this.picLoading = true

    this.app.userService.retrievePhoto(userid)
      .subscribe(res => {
        if (res['message']) {
          this.picLoading = false
          this.picPreview = ''
          return
        }
        this.picLoading = false
        this.createImageFromBlob(res)
      }, err => {
          this.picLoading = false
    })
  }

  createImageFromBlob(image) {
    
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.picPreview = reader.result;
      this.app.setProfilePics(this.picPreview)
    }, false);
    if (image) {
      reader.readAsDataURL(image);
    }

    // document.getElementById("image").style.backgroundImage = this.picPreview;
  }

  // uploadImage(event) {
  //   this.picLoading = true
  //   let accountid = this.app.helperService.getClientId()

  //   this.app.userService.uploadPhoto(accountid, event)
  //     .subscribe(res => {
  //       if (res['message'] == MessageUtil.RESPONSE_SUCCESS) {
  //         this.picLoading = false
  //         this.uploadProfilePic(event)
  //       }
  //       else {
  //         this.picLoading = false
  //         this.app.snackBar.open(res['data'], 'Dismiss',{
  //           duration: MessageUtil.TIMEOUT_DURATION
  //         })
  //       }
  //     }, err => {
  //       this.picLoading = false
  //       this.app.snackBar.open(MessageUtil.INTERNAL_SERVER_ERROR, 'Dismiss',{
  //         duration: MessageUtil.TIMEOUT_DURATION
  //       })
  //   })
  // }

  // uploadProfilePic(event) {
  //   const reader = new FileReader();

  //   const [file] = event.target.files;
  //   reader.readAsDataURL(file);
  //   reader.onload = () => {
  //     this.picPreview = reader.result as string;
  //     this.app.setProfilePics(this.picPreview)
  //   }
  // }

}
